module.exports = __webpack_public_path__ + "img/home_employers.937dbac2.jpg";